import BaseModel from '../base/BaseModel.model';
export default class DoctoralThesi extends BaseModel {
    
    public evaluatedStudent?: string;
    public institution?: string;
    public titleProposal?: string;
    public starYear?: Date | any;
    public endYear?:  Date | any;
    public isAdvisorOrMentor:boolean | any;
    public name?:string;
    constructor() {
      super();
      this.init();
    }
  
    init() {
      this.evaluatedStudent = "";
      this.institution = "";
      this.titleProposal = "";
      this.isAdvisorOrMentor = null;
      this.endYear = null;
      this.starYear = null;
      this.name = "";
    }
}